package ai.beakman.undercover.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** Fase da partida dentro de uma sala (espelha o `stage` do app original). */
@Serializable
enum class Stage {
    @SerialName("lobby") LOBBY,
    @SerialName("reveal") REVEAL,
    @SerialName("timer") TIMER,
    @SerialName("vote") VOTE,
    @SerialName("result") RESULT,
}

/** Tema do jogo (apenas em memória — só id/name/emoji e a palavra sorteada vão ao Firestore). */
data class Theme(
    val id: String,
    val name: String,
    val emoji: String,
    val words: List<WordHint>,
)

data class WordHint(val word: String, val hint: String)

/**
 * Documento `rooms/{code}` no Firestore (modelo público, porte 1:1 do Supabase).
 * Defaults em todos os campos para a desserialização do GitLive funcionar.
 */
@Serializable
data class Room(
    val code: String = "",
    val hostClientId: String = "",
    val lang: String = "pt", // idioma da sala (snapshot na criação); deserialização segura
    val themeId: String = "",
    val themeName: String = "",
    val themeEmoji: String = "",
    val numInfiltrators: Int = 1,
    val timerSeconds: Int = 180,
    val stage: Stage = Stage.LOBBY,
    val word: String? = null,
    val hint: String? = null,
    val infiltratorPlayerIds: List<String> = emptyList(),
    @Serializable(with = EpochMillisSerializer::class)
    val timerStartedAt: Long? = null, // epoch millis
    val round: Int = 0,
    @Serializable(with = EpochMillisSerializer::class)
    val createdAt: Long = 0L,         // epoch millis
)

/** Documento `rooms/{code}/players/{clientId}`. doc id == clientId. */
@Serializable
data class Player(
    val clientId: String = "",
    val name: String = "",
    val ready: Boolean = false,
    @Serializable(with = EpochMillisSerializer::class)
    val joinOrder: Long = 0L, // epoch millis na entrada → ordem de votação
)

/** Documento `rooms/{code}/votes/{voterClientId}`. doc id == clientId do votante. */
@Serializable
data class Vote(
    val voterId: String = "",
    val votedForIds: List<String> = emptyList(),
)

/** Resultado calculado de uma rodada (não persistido). */
data class GameResult(
    val tally: Map<String, Int>,    // playerId -> nº de votos
    val accusedIds: List<String>,   // mais votados (empate possível)
    val infiltratorIds: List<String>,
    val playersWon: Boolean,        // jogadores comuns venceram (pegaram TODOS os infiltrados)
    val caughtAny: Boolean,
)
